import type { ProductCategory } from "./products";

export type ServiceSummary = {
  id: ProductCategory;
  name: string;
  shortDescriptor: string;
  headline: string;
  description: string;
  featureLabels: string[];
  ctaLabel: string;
  href: string;
};

export const services: ServiceSummary[] = [
  {
    id: "vps",
    name: "VPS Hosting",
    shortDescriptor: "Flexible virtual servers",
    headline: "Flexible Virtual Servers",
    description:
      "Launch configurable virtual server environments for websites, applications, development workloads and business platforms.",
    featureLabels: [
      "Configurable resources",
      "Administrative control",
      "Multiple deployment options",
      "Easy upgrade path",
    ],
    ctaLabel: "Explore VPS Plans",
    href: "/vps-hosting",
  },
  {
    id: "dedicated",
    name: "Dedicated Servers",
    shortDescriptor: "Resources dedicated to you",
    headline: "Resources Dedicated to Your Workloads",
    description:
      "Run demanding websites, databases and business applications on server infrastructure dedicated to your organisation.",
    featureLabels: [
      "Dedicated server resources",
      "Greater workload control",
      "Custom configurations",
      "Suitable for intensive applications",
    ],
    ctaLabel: "View Dedicated Servers",
    href: "/dedicated-servers",
  },
  {
    id: "cloud",
    name: "Cloud Solutions",
    shortDescriptor: "Infrastructure that grows with you",
    headline: "Cloud Infrastructure That Grows With You",
    description:
      "Build flexible cloud environments for modern applications, distributed workloads and changing business requirements.",
    featureLabels: [
      "Scalable architecture",
      "Flexible deployment",
      "Business continuity options",
      "Custom cloud environments",
    ],
    ctaLabel: "Explore Cloud Solutions",
    href: "/cloud-solutions",
  },
  {
    id: "email",
    name: "Business Email",
    shortDescriptor: "Professional email for teams",
    headline: "Professional Email for Modern Teams",
    description:
      "Give your organisation a secure and professional communication system with feature-rich business mailboxes.",
    featureLabels: [
      "30 GB mailbox",
      "Advanced email features",
      "Professional business identity",
      "Multi-device access",
    ],
    ctaLabel: "Get Business Email",
    href: "/email-solutions",
  },
  {
    id: "security",
    name: "Security & Network",
    shortDescriptor: "Protect every layer",
    headline: "Protect Every Layer of Your Infrastructure",
    description:
      "Strengthen your digital infrastructure with security and networking solutions designed around availability, access and protection.",
    featureLabels: [
      "Network protection",
      "Firewall solutions",
      "Secure connectivity",
      "Infrastructure monitoring",
    ],
    ctaLabel: "Discuss Your Security Needs",
    href: "/security-network",
  },
];
